import {
  FlightIcon,
  StayIcon,
  TransferIcon,
  TtdIcon,
} from "../common/IconList/IconList";

export const isMobile = window.innerWidth <= 480;

export const sections = {
  1: [
    {
      id: "onward-flight",
      label: "Onward flight",
      icon: <FlightIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "onward-transfer",
      label: "Onward transfer",
      icon: <TransferIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "stay",
      label: "Stay",
      icon: <StayIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "ttd",
      label: "Things to do",
      icon: <TtdIcon sx={{ color: "#fff" }} />,
    },
  ],
  2: [
    {
      id: "Morning",
      label: "Morning Things to do",
      icon: <TtdIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "Afternoon",
      label: "Afternoon Things to do",
      icon: <TtdIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "Evening",
      label: "Evening Things to do",
      icon: <TtdIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "day-transfer",
      label: "Day transfer",
      icon: <TransferIcon sx={{ color: "#fff" }} />,
    },
  ],
  3: [
    {
      id: "ttd",
      label: "Things to do",
      icon: <TtdIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "return-transfer",
      label: "Return transfer",
      icon: <TransferIcon sx={{ color: "#fff" }} />,
    },
    {
      id: "return-flight",
      label: "Return flight",
      icon: <FlightIcon sx={{ color: "#fff" }} />,
    },
  ],
};

export const getHotelImages = (images) => {
  if (!images) return [];

  return images
    .map((item, index) => {
      const url = item.url;
      const alt = `${item.category} ${index + 1}`;

      if (url) {
        return { url, alt, label: item.category };
      }

      return null;
    })
    .filter(Boolean); // Remove nulls
};

export const mergeRefs =
  (...refs) =>
  (el) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(el);
      } else if (ref && typeof ref === "object") {
        ref.current = el;
      }
    });
  };
